import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {},
    },
    'zh-HK': {
        translation: {},
    },
};

const loadTranslations = async () => {
    try {
        // Attempt to fetch English translations
        const response = await fetch(`${process.env.REACT_APP_TRANSLATION_LOCATION}en.json`);
        if (!response.ok) {
            throw new Error('Failed to fetch English translations');
        }

        const enTranslations = await response.json();
        resources.en.translation = enTranslations;

    } catch (error) {
        console.error('Error fetching English translations:', error);
        // Fallback to the default translation location
        const defaultResponse = await fetch(`${process.env.REACT_APP_DEFAULT_TRANSLATION_LOCATION}en.json`);
        const defaultEnTranslations = await defaultResponse.json();
        resources.en.translation = defaultEnTranslations;
    }

    try {
        // Attempt to fetch Chinese (Hong Kong) translations
        const zhHKResponse = await fetch(`${process.env.REACT_APP_TRANSLATION_LOCATION}zh-HK.json`);

        if (!zhHKResponse.ok) {
            throw new Error('Failed to fetch Chinese (HK) translations');
        }

        const zhHKTranslations = await zhHKResponse.json();
        resources['zh-HK'].translation = zhHKTranslations;

    } catch (error) {
        console.error('Error fetching Chinese (HK) translations:', error);
        // Fallback to the default translation location
        const defaultZhHKResponse = await fetch(`${process.env.REACT_APP_DEFAULT_TRANSLATION_LOCATION}zh-HK.json`);
        const defaultZhHKTranslations = await defaultZhHKResponse.json();
        resources['zh-HK'].translation = defaultZhHKTranslations;
    }
};

loadTranslations().then(() => {
    const preferredLanguage = localStorage.getItem('preferredLanguage') || process.env.REACT_APP_DEFAULT_LANGUAGE; // Get preferred language or default to 'zh-HK'
    i18n
        .use(initReactI18next) // Passes i18n down to React
        .init({
            resources,
            lng: preferredLanguage, // Default language
            fallbackLng: 'en', // Fallback language
            interpolation: {
                escapeValue: false, // React already does escaping
            },
        });
});

export default i18n;